<template>
  <div class="oil-order-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>加油订单列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card" shadow="hover">
      <!-- 搜索与筛选 -->
      <div class="search-section">
        <el-form
                size="mini"
                :inline="true"
                :model="searchForm"
                ref="searchForRef"
                label-width="100px"
                autocomplete="on"
        >
          <el-row :gutter="24">
            <el-col :span="18">
              <el-form-item label="关键字">
                <el-input
                        v-model="searchForm.keyword"
                        placeholder="请输入关键字"
                        clearable
                        type="text"
                        prefix-icon="el-icon-search"
                ></el-input>
              </el-form-item>
              <el-form-item label="车牌号">
                <el-input
                        v-model="searchForm.car_number"
                        placeholder="请输入车牌号"
                        clearable
                        type="text"
                ></el-input>
              </el-form-item>
              <el-form-item label="开票">
                <el-select
                        clearable
                        v-model="searchForm.is_invoice"
                        placeholder="请选择开票状态"
                        style="width: 120px"
                >
                  <el-option key="" label="全部" value=""></el-option>
                  <el-option key="1" label="已开" value="1"></el-option>
                  <el-option key="0" label="未开" value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="创建时间">
                <el-date-picker
                        v-model="searchForm.start_end_date"
                        type="daterange"
                        align="right"
                        size="mini"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="startEndOptions"
                        style="width: 240px"
                ></el-date-picker>
              </el-form-item>

            </el-col>
            <el-col :span="6" style="text-align: right">
              <el-button
                      type="primary"
                      size="mini"
                      icon="el-icon-search"
                      @click="searchSubmit"
                      :loading="searchLoading"
              >
                查询
              </el-button>
              <div class="toggle-button" @click="isCollapsed = !isCollapsed">
                <span>筛选条件</span>
                <i :class="collapseIcon" class="el-icon--right"></i>
              </div>
            </el-col>
          </el-row>

          <el-collapse-transition>
            <div v-show="!isCollapsed" class="condition-content">
              <el-form-item label="支付状态">
                <el-select
                        clearable
                        v-model="searchForm.pay_status"
                        placeholder="请选择支付状态"
                        style="width: 120px"
                >
                  <el-option key="" label="全部" value=""></el-option>
                  <el-option key="1" label="已支付" value="1"></el-option>
                  <el-option key="0" label="待付" value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-collapse-transition>
        </el-form>
      </div>

      <!-- 统计卡片 -->
<!--      <div class="statistics-section">-->
<!--        <el-row :gutter="24">-->
<!--          <el-col :span="6">-->
<!--            <div class="statistic-card">-->
<!--              <el-statistic-->
<!--                      group-separator=","-->
<!--                      :precision="2"-->
<!--                      title="待开票金额"-->
<!--                      title-class="statistic-title"-->
<!--              >-->
<!--                <template slot="formatter">-->
<!--                  <span class="statistic-value">{{sumAmount['noInvoiceAmount']||0}}</span>-->
<!--                </template>-->
<!--              </el-statistic>-->
<!--            </div>-->
<!--          </el-col>-->
<!--          <el-col :span="6">-->
<!--            <div class="statistic-card">-->
<!--              <el-statistic-->
<!--                      title="已开票金额"-->
<!--                      :precision="2"-->
<!--                      title-class="statistic-title"-->
<!--              >-->
<!--                <template slot="formatter">-->
<!--                  <span class="statistic-value">{{(parseFloat(sumAmount['payAmount']||0) - parseFloat(sumAmount['noInvoiceAmount']||0)).toFixed(2)}}</span>-->
<!--                </template>-->
<!--              </el-statistic>-->
<!--            </div>-->
<!--          </el-col>-->
<!--          <el-col :span="6">-->
<!--            <div class="statistic-card">-->
<!--              <el-statistic-->
<!--                      group-separator=","-->
<!--                      :precision="2"-->
<!--                      decimal-separator="."-->
<!--                      title="订单总金额"-->
<!--                      title-class="statistic-title"-->
<!--              >-->
<!--                <template slot="formatter">-->
<!--                  <span class="statistic-value">{{sumAmount['payAmount']||0}}</span>-->
<!--                </template>-->
<!--              </el-statistic>-->
<!--            </div>-->
<!--          </el-col>-->
<!--          <el-col :span="6">-->
<!--            <div class="statistic-card">-->
<!--              <el-statistic title="退款总额" title-class="statistic-title">-->
<!--                <template slot="formatter">-->
<!--                  <span class="statistic-value">0</span>-->
<!--                </template>-->
<!--              </el-statistic>-->
<!--            </div>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </div>-->

      <!-- 批量操作栏 -->
      <div class="batch-operation-bar" v-if="selectedOrders.length > 0">
        <el-button-group>
          <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-document"
                  @click="batchDownloadInvoice"
                  :loading="batchInvoiceLoading"
                  :disabled="!hasInvoiceToDownload"
          >
            批量下载发票 ({{selectedOrders.length}})
          </el-button>
          <el-button
                  type="success"
                  size="mini"
                  icon="el-icon-tickets"
                  @click="batchDownloadVoucher"
                  :loading="batchVoucherLoading"
                  :disabled="!hasVoucherToDownload"
          >
            批量下载凭证 ({{selectedOrders.length}})
          </el-button>
        </el-button-group>
        <el-button
                size="mini"
                @click="clearSelection"
        >
          取消选择
        </el-button>
      </div>

      <!-- 表格 -->
      <el-table
              ref="multipleTable"
              :data="tableLoadData"
              height="450"
              stripe
              border
              size="mini"
              @selection-change="handleSelectionChange"
              v-loading="tableLoading"
              element-loading-text="数据加载中..."
              element-loading-spinner="el-icon-loading"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column :index="indexMethod" type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column
                label="交易日期"
                width="120"
                :show-overflow-tooltip='true'
                align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.order_pay_time }}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="交易金额(元)"
                width="100"
                align="right"
        >
          <template slot-scope="scope">
            <span class="amount">{{ formatNumber(scope.row.trade_amount) }}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="油站提现金额(元)"
                width="120"
                align="right"
        >
          <template slot-scope="scope">
            <span class="amount">{{ formatNumber(scope.row.withdraw_amount) }}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="营销费用(元)"
                width="100"
                align="right"
        >
          <template slot-scope="scope">
            <span class="amount">{{ formatNumber(scope.row.business_amount) }}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="油站名称"
                width="300"
                :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.oilshop?scope.row.oilshop.name:''}}</span>
          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--                label="运企名称"-->
<!--                width="120"-->
<!--                :show-overflow-tooltip='true'-->
<!--        >-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ scope.row.lgsshop?scope.row.lgsshop.name:''}}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--                label="司机手机号"-->
<!--                width="120"-->
<!--                :show-overflow-tooltip='true'-->
<!--                align="center"-->
<!--        >-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ formatPhoneNumber(scope.row.owner?scope.row.owner.tel:'') }}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--                label="司机姓名"-->
<!--                width="120"-->
<!--                :show-overflow-tooltip='true'-->
<!--        >-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ scope.row.owner?scope.row.owner.name:''}}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--                label="车牌号"-->
<!--                width="100"-->
<!--                :show-overflow-tooltip='true'-->
<!--                align="center"-->
<!--        >-->
<!--          <template slot-scope="scope">-->
<!--            <span>{{ scope.row.carinfo?scope.row.carinfo.car_number:''}}</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column
                label="开票状态"
                :show-overflow-tooltip='true'
                width="100"
                align="center"
        >
          <template slot-scope="scope">
            <div class="status-tag">
              <el-tag
                      v-if="scope.row.is_invoice==1"
                      type="success"
                      size="mini"
              >
                已开
              </el-tag>
              <el-tag
                      v-else
                      type="info"
                      size="mini"
              >
                未开
              </el-tag>
              <div v-if="scope.row.is_invoice==1" class="time-text">
                {{ scope.row.time_invoice?timeFormat(scope.row.time_invoice):''}}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
                label="支付状态"
                :show-overflow-tooltip='true'
                width="100"
                align="center"
        >
          <template slot-scope="scope">
            <el-tag
                    v-if="scope.row.pay_status==2"
                    type="success"
                    size="mini"
            >
              已支付
            </el-tag>
            <el-tag
                    v-else
                    type="warning"
                    size="mini"
            >
              待付
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
                fixed="right"
                label="操作"
                width="180"
                align="center"
        >
          <template slot-scope="scope">
            <div class="operation-buttons">
              <!-- 发票下载 -->
              <el-tooltip
                      v-if="scope.row.pay_status==2 && scope.row.file_url"
                      :content="downloadStatus[scope.row.id] && downloadStatus[scope.row.id].invoice ? '已下载' : '下载发票'"
                      placement="top"
              >
                <el-button
                        size="mini"
                        type="text"
                        icon="el-icon-document"
                        :class="{'downloaded': downloadStatus[scope.row.id] && downloadStatus[scope.row.id].invoice}"
                        @click="downloadInvoice(scope.row)"
                >
                  {{ downloadStatus[scope.row.id] && downloadStatus[scope.row.id].invoice ? '已下载' : '发票' }}
                </el-button>
              </el-tooltip>

              <!-- 凭证下载 -->
<!--              <el-tooltip-->
<!--                      v-if="scope.row.pay_status==2"-->
<!--                      :content="downloadStatus[scope.row.id] && downloadStatus[scope.row.id].voucher ? '已下载' : '下载凭证'"-->
<!--                      placement="top"-->
<!--              >-->
<!--                <el-button-->
<!--                        size="mini"-->
<!--                        type="text"-->
<!--                        icon="el-icon-tickets"-->
<!--                        :class="{'downloaded': downloadStatus[scope.row.id] && downloadStatus[scope.row.id].voucher}"-->
<!--                        @click="downPay(scope.row)"-->
<!--                >-->
<!--                  {{ downloadStatus[scope.row.id] && downloadStatus[scope.row.id].voucher ? '已下载' : '凭证' }}-->
<!--                </el-button>-->
<!--              </el-tooltip>-->

              <!-- 详情 -->
<!--              <el-tooltip content="查看详情" placement="top">-->
<!--                <el-button-->
<!--                        size="mini"-->
<!--                        @click="showGoods(scope.row)"-->
<!--                        type="text"-->
<!--                        icon="el-icon-view"-->
<!--                >-->
<!--                  详情-->
<!--                </el-button>-->
<!--              </el-tooltip>-->
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[10, 20, 30, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 订单详情抽屉 -->
    <el-drawer
            title="订单详情"
            :visible.sync="drawer"
            size="60%"
            v-if="om"
            :with-header="false"
    >
      <div class="drawer-content">
        <h3 class="drawer-title">订单详情</h3>
        <el-descriptions title="基本信息" direction="horizontal" :column="3" border>
          <template slot="extra">
            <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-download"
                    @click="downloadInvoice(om)"
            >
              下载发票
            </el-button>
            <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-download"
                    @click="downPay(om)"
            >
              下载凭证
            </el-button>
          </template>
          <el-descriptions-item label="订单编号">{{om.sn}}</el-descriptions-item>
          <el-descriptions-item label="总金额">{{formatNumber(om.order_amount)}}</el-descriptions-item>
          <el-descriptions-item label="下单日期">{{om.add_time|timeFormat}}</el-descriptions-item>
          <el-descriptions-item label="油站名称">{{om.oilshop.name||''}}</el-descriptions-item>
          <el-descriptions-item label="运企名称">{{om.lgsshop.name||''}}</el-descriptions-item>
          <el-descriptions-item label="司机">{{om.owner.name||''}}/{{om.carinfo.car_number||''}}</el-descriptions-item>
          <el-descriptions-item label="司机手机号">{{formatPhoneNumber(om.owner?om.owner.tel:'')}}</el-descriptions-item>
        </el-descriptions>

        <el-descriptions
                v-if="om.invoice"
                title="发票详情"
                direction="horizontal"
                :column="3"
                border
                style="margin-top: 20px;"
        >
          <el-descriptions-item label="名称">{{om.invoice.name}}</el-descriptions-item>
          <el-descriptions-item label="税号">{{om.invoice.tax_id}}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{om.invoice.mobile}}</el-descriptions-item>
          <el-descriptions-item label="邮箱">{{om.invoice.email||''}}</el-descriptions-item>
          <el-descriptions-item label="附件">
            <el-image
                    style="width: 100px; height: 100px"
                    :src="om.file_url||''"
                    fit="fill"
            ></el-image>
          </el-descriptions-item>
          <el-descriptions-item label="开票日期">{{om.time_invoice|timeFormat}}</el-descriptions-item>
        </el-descriptions>

        <el-table
                style="margin-top: 20px;"
                :data="goods_list"
                size="mini"
                stripe
                border
        >
          <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
          <el-table-column
                  label="产品名称"
                  width="150"
                  :show-overflow-tooltip='true'
          >
            <template slot-scope="scope">
              <span>{{scope.row.product_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
                  label="数量"
                  width="80"
                  :show-overflow-tooltip='true'
                  align="center"
          >
            <template slot-scope="scope">
              <span>{{scope.row.num}}</span>
            </template>
          </el-table-column>
          <el-table-column
                  label="单位"
                  width="80"
                  :show-overflow-tooltip='true'
                  align="center"
          >
            <template slot-scope="scope">
              <span>{{scope.row.unit}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>

    <!-- 发票表单 -->
    <eInvoiceForm
            :formData="formData1"
            :visible.sync="visible1"
            :title="title1"
            :closeForm="closeForm1"
            v-on:eventChoose="eChooseRs1"
    />
  </div>
</template>

<script>
  import moment from 'moment'     //日期时间转换
  import eInvoiceForm from "../common/eInvoiceForm.vue";

  export default {
    name: "lgsOilOrderList",
    components: {
      eInvoiceForm
    },
    props: {},
    data() {
      return {
        sumAmount: [],
        om: null,
        formData1: {item: null},
        visible1: false,
        title1: '',
        invoiceVisible: false,
        isCollapsed: true,
        drawer: false,
        goods_list: [],
        tableLoading: false,
        searchLoading: false,
        batchInvoiceLoading: false,
        batchVoucherLoading: false,
        selectedOrders: [], // 选中的订单
        downloadStatus: {}, // 下载状态记录 {orderId: {invoice: true/false, voucher: true/false}}

        // 日期选择器快捷选项
        startEndOptions: {
          shortcuts: [
            {
              text: '今天',
              onClick(picker) {
                const start = new Date();
                start.setHours(0, 0, 0, 0);
                const end = new Date();
                end.setHours(23, 59, 59, 999);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '昨天',
              onClick(picker) {
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24);
                start.setHours(0, 0, 0, 0);
                const end = new Date();
                end.setTime(end.getTime() - 3600 * 1000 * 24);
                end.setHours(23, 59, 59, 999);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '最近7天',
              onClick(picker) {
                const end = new Date();
                end.setHours(23, 59, 59, 999);
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                start.setHours(0, 0, 0, 0);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '最近30天',
              onClick(picker) {
                const end = new Date();
                end.setHours(23, 59, 59, 999);
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                start.setHours(0, 0, 0, 0);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '本月',
              onClick(picker) {
                const start = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                start.setHours(0, 0, 0, 0);
                const end = new Date();
                end.setHours(23, 59, 59, 999);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '上月',
              onClick(picker) {
                const start = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
                start.setHours(0, 0, 0, 0);
                const end = new Date(new Date().getFullYear(), new Date().getMonth(), 0);
                end.setHours(23, 59, 59, 999);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        },

        // 搜索
        searchForm: {
          is_invoice: '',
          name: "",
          keyword: '',
          car_number: '', // 新增车牌号查询条件
          start_end_date: '',
          status: '',
          pay_status: ''
        },
        searchRules: {
          name: [
            { required: true, message: "请输入名称", trigger: "blur" }
          ],
        },

        // 数据
        tableLoadData: [],
        pageNum: 1, // 当前页码
        pageSize: 10, // 每页大小
        total: 0, //总条目数

        showType: '',
        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            {
              min: 3,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],
        },

        dialogFormVisible: false,
        title: '',
        form: {
          name: '',
        },
      };
    },
    computed: {
      collapseIcon() {
        return this.isCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
      },
      // 检查是否有可下载发票的订单
      hasInvoiceToDownload() {
        return this.selectedOrders.some(order =>
                order.pay_status == 2 && order.file_url
        );
      },
      // 检查是否有可下载凭证的订单
      hasVoucherToDownload() {
        return this.selectedOrders.some(order =>
                order.pay_status == 2
        );
      }
    },
    created() {
      this.getOilOrderSumAmount();
      this.showType = this.$route.query.showType;
      console.log(this.showType,888);
      this.DataList()
      this.departData()
    },
    mounted() {
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD");
      },
      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      statusFilter(status) {
        if (status == 0) {
          return "待审核";
        } else if (status == 1) {
          return "已审核";
        } else if (status == 2) {
          return "已出单";
        } else if (status == 3) {
          return "已完成";
        } else if (status == 4) {
          return "取保";
        } else if (status == 5) {
          return "退单";
        }
      },
    },
    methods: {
      // 手机号脱敏处理
      formatPhoneNumber(phone) {
        if (!phone) return '';
        if (phone.length === 11) {
          return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
        }
        return phone;
      },

      // 处理多选
      handleSelectionChange(val) {
        this.selectedOrders = val;
      },

      // 批量下载发票
      batchDownloadInvoice() {
        if (this.selectedOrders.length === 0) {
          this.$message.warning('请先选择要下载发票的订单');
          return;
        }

        if (!this.hasInvoiceToDownload) {
          this.$message.warning('选中的订单中没有可下载的发票');
          return;
        }

        this.batchInvoiceLoading = true;
        let downloadPromises = [];

        // 遍历选中的订单，收集发票下载任务
        this.selectedOrders.forEach(order => {
          // 下载发票
          if (order.pay_status == 2 && order.file_url) {
            downloadPromises.push(this.downloadInvoice(order, true));
          }
        });

        // 执行所有下载任务
        Promise.all(downloadPromises)
                .then(() => {
                  this.$message.success(`成功下载 ${downloadPromises.length} 个发票文件`);
                  this.batchInvoiceLoading = false;
                })
                .catch(error => {
                  console.error('批量下载发票出错:', error);
                  this.$message.error('部分发票文件下载失败');
                  this.batchInvoiceLoading = false;
                });
      },

      // 批量下载凭证
      batchDownloadVoucher() {
        if (this.selectedOrders.length === 0) {
          this.$message.warning('请先选择要下载凭证的订单');
          return;
        }

        if (!this.hasVoucherToDownload) {
          this.$message.warning('选中的订单中没有可下载的凭证');
          return;
        }

        this.batchVoucherLoading = true;
        let downloadPromises = [];

        // 遍历选中的订单，收集凭证下载任务
        this.selectedOrders.forEach(order => {
          // 下载凭证
          if (order.pay_status == 2) {
            downloadPromises.push(this.downPay(order, true));
          }
        });

        // 执行所有下载任务
        Promise.all(downloadPromises)
                .then(() => {
                  this.$message.success(`成功下载 ${downloadPromises.length} 个凭证文件`);
                  this.batchVoucherLoading = false;
                })
                .catch(error => {
                  console.error('批量下载凭证出错:', error);
                  this.$message.error('部分凭证文件下载失败');
                  this.batchVoucherLoading = false;
                });
      },

      // 清除选择
      clearSelection() {
        this.$refs.multipleTable.clearSelection();
      },

      // 下载发票
      downloadInvoice(row, isBatch = false) {
        if (!row.file_url) {
          if (!isBatch) this.$message.warning('该订单暂无发票');
          return Promise.resolve();
        }

        return new Promise((resolve, reject) => {
          try {
            // 创建下载链接
            const link = document.createElement('a');
            link.href = row.file_url;
            link.download = `发票_${row.id}.pdf`;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // 更新下载状态
            this.$set(this.downloadStatus, row.id, {
              ...this.downloadStatus[row.id],
              invoice: true
            });

            // 调用后台接口更新订单下载状态 d_invoice
            this.updateDownloadStatus(row.id, 'invoice');

            if (!isBatch) {
              this.$message.success('发票下载成功');
            }
            resolve();
          } catch (error) {
            console.error('发票下载失败:', error);
            if (!isBatch) {
              this.$message.error('发票下载失败');
            }
            reject(error);
          }
        });
      },

      // 更新下载状态到后台
      updateDownloadStatus(orderId, type) {
        const param = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          order_id: orderId,
          type: type // 'invoice' 或 'voucher'
        };

        // 调用后台接口更新下载状态
        this.$axios.updateDownloadStatus(param).then(res => {
          if(res.code == 200) {
            console.log(`${type === 'invoice' ? '发票' : '凭证'}下载状态更新成功`);
          } else {
            console.error(`${type === 'invoice' ? '发票' : '凭证'}下载状态更新失败:`, res.msg);
          }
        }).catch(error => {
          console.error(`${type === 'invoice' ? '发票' : '凭证'}下载状态更新接口错误:`, error);
        });
      },

      getOilOrderSumAmount(){
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          lgs_shop_id: sessionStorage.getItem('shop_id'),
        }
        this.$axios.findOilOrderSumAmount(param).then(res => {
          if(res.code == 200){
            this.sumAmount = res.data
          }
        }).catch(error => {
          console.log(error);
        })
      },

      formatNumber(num) {
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(num);
      },

      downPay(item, isBatch = false){
        // 检查是否已下载
        if (this.downloadStatus[item.id] && this.downloadStatus[item.id].voucher) {
          if (!isBatch) this.$message.info('凭证已下载');
          return Promise.resolve();
        }

        //下载凭证
        const param = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          order_id: item.id
        }

        return this.$axios.yeeDown(param).then(res => {
          if(res.code == 200){
            // Base64 编码的 PDF 数据
            const base64Data = res.data.data;

            // 将 Base64 转换为 Blob
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);

            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });

            // 创建下载链接
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `凭证_${item.id}.pdf`;
            document.body.appendChild(link);
            link.click();

            // 清理
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            // 更新下载状态
            this.$set(this.downloadStatus, item.id, {
              ...this.downloadStatus[item.id],
              voucher: true
            });

            // 调用后台接口更新订单下载状态 d_voucher
            this.updateDownloadStatus(item.id, 'voucher');

            if (!isBatch) {
              this.$message.success('凭证下载成功');
            }
          }
        }).catch(error => {
          console.log(error);
          if (!isBatch) {
            this.$message.error('凭证下载失败');
          }
          throw error;
        });
      },

      goInvoice(row){
        this.title1 = "上传发票";
        this.formData1.item = row;
        this.visible1 = true;
      },

      closeForm1(){
        this.visible1 = false;
      },

      eChooseRs1(rs){
        console.log(rs)
      },

      // 查询按钮点击事件
      searchSubmit() {
        this.searchLoading = true;
        this.pageNum = 1;
        this.tableLoadData = [];
        this.total = 0;
        this.DataList();
      },

      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },

      showGoods(row){
        this.drawer = true;
        this.om = row;
        this.goods_list = row.goods;
      },

      getAge(birth){
        if(birth){
          let birthday = birth;
          let now = new Date().getTime();
          let hours = (now-birthday*1000)/3600000;
          let year = Math.floor(hours / (24 * 30 * 12));
          return year
        }else{
          return null
        }
      },

      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },

      DataList(){
        this.tableLoading = true;
        const param = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          // 添加搜索条件
          keyword: this.searchForm.keyword,
          car_number: this.searchForm.car_number, // 新增车牌号查询条件
          is_invoice: this.searchForm.is_invoice,
          pay_status: this.searchForm.pay_status,
          start_date: this.searchForm.start_end_date && this.searchForm.start_end_date[0]
                  ? moment(this.searchForm.start_end_date[0]).format('YYYY-MM-DD') : '',
          end_date: this.searchForm.start_end_date && this.searchForm.start_end_date[1]
                  ? moment(this.searchForm.start_end_date[1]).format('YYYY-MM-DD') : '',
        }
        this.$axios.findDayaBillThirdByUserListP(param).then(res => {
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
          this.tableLoading = false;
          this.searchLoading = false;
        }).catch(error => {
          console.log(error);
          this.tableLoading = false;
          this.searchLoading = false;
        })
      },

      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },

      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },

      departData(){
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res => {
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error => {
          console.log(error);
        })
      },

      // 新增
      addData() {
        this.$router.push('/hisOrderForm')
      },

      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },

      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res => {
                console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res => {
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }
          }
        })
      },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res => {
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error => {
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },
    },
  };
</script>

<style scoped>
  .oil-order-container {
    padding: 20px;
  }

  .breadcrumb {
    margin-bottom: 20px;
  }

  .box-card {
    border-radius: 8px;
    border: 1px solid #ebeef5;
  }

  .search-section {
    padding-bottom: 10px;
    border-bottom: 1px solid #f0f0f0;
  }

  .toggle-button {
    cursor: pointer;
    color: #409EFF;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    margin-left: 10px;
  }

  .toggle-button:hover {
    color: #66b1ff;
  }

  .condition-content {
    padding-top: 15px;
    border-top: 1px dashed #e8e8e8;
    margin-top: 10px;
  }

  .statistics-section {
    margin: 20px 0;
    padding: 15px 0;
    border-bottom: 1px solid #f0f0f0;
  }

  .statistic-card {
    padding: 15px;
    background: #f8f9fa;
    border-radius: 6px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  }

  .statistic-title {
    color: #606266;
    font-size: 14px;
    margin-bottom: 8px;
    display: block;
  }

  .statistic-value {
    font-size: 20px;
    font-weight: bold;
    color: #303133;
  }

  .batch-operation-bar {
    padding: 10px 15px;
    background-color: #f0f9ff;
    border: 1px solid #d1ecf1;
    border-radius: 4px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .operation-buttons {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .operation-buttons .el-button {
    margin: 2px;
  }

  .operation-buttons .downloaded {
    color: #67C23A !important;
  }

  .status-tag {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .time-text {
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
  }

  .amount {
    font-weight: bold;
    color: #E6A23C;
  }

  .pagination-section {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }

  .drawer-content {
    padding: 20px;
  }

  .drawer-title {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e8e8e8;
    color: #303133;
    font-size: 18px;
    font-weight: 600;
  }

  /* 响应式调整 */
  @media (max-width: 1200px) {
    .oil-order-container {
      padding: 15px;
    }

    .statistics-section .el-col {
      margin-bottom: 15px;
    }
  }

  @media (max-width: 768px) {
    .oil-order-container {
      padding: 10px;
    }

    .search-section .el-form-item {
      margin-bottom: 10px;
    }

    .batch-operation-bar {
      flex-direction: column;
      align-items: flex-start;
    }

    .batch-operation-bar .el-button {
      margin-bottom: 5px;
    }
  }
</style>
